<script setup lang="ts">
import { getAnalyticsTracker } from '@/tracking/analytics/plugin.ts'
import { ref, nextTick } from 'vue'
const analytics = getAnalyticsTracker()
const props = defineProps({
  contentType: {
    type: String,
    required: true
  }
})

const viewMore = ref<HTMLElement>()

const model = defineModel()
model.value = true

async function update() {
  model.value = !model.value
  if (model.value) {
    analytics.sendEvent('Viewed More Library Content', { content_type: props.contentType })
  } else {
    await nextTick()
    viewMore.value?.scrollIntoView({ behavior: 'smooth', block: 'center' })
  }
}
</script>
<template>
  <button class="text-link m-auto block cursor-pointer text-center pb-10" @click="update" ref="viewMore">
    View {{ model ? 'more' : 'less' }}
    <span class="material-icons-outlined absolute text-display-sm">{{
      model ? 'keyboard_arrow_down' : 'keyboard_arrow_up'
    }}</span>
  </button>
</template>
